module.exports = __webpack_public_path__ + "img/dcu30-char-3.b265a75c.png";